document.addEventListener('DOMContentLoaded', function() {
    function updatePrice(swatch) {
        const selectedPrice = swatch.getAttribute('data-price');
        const selectedCompareAtPrice = swatch.getAttribute('data-compare-at-price');

        const productItem = swatch.closest('.product-item');

        if (productItem) {
            const priceElement = productItem.querySelector('.price--highlight');
            const compareAtPriceElement = productItem.querySelector('.price--compare');
            const percentageDifferenceElement = productItem.querySelector('.percentage_difference');

            if (priceElement) {
                priceElement.textContent = Shopify.formatMoney(selectedPrice, Shopify.money_format);
            }

            if (compareAtPriceElement) {
                const compareAtPriceNumeric = parseFloat(selectedCompareAtPrice.replace(/[^0-9.-]+/g, ""));

                if (compareAtPriceNumeric > 0) {
                    compareAtPriceElement.textContent = Shopify.formatMoney(selectedCompareAtPrice, Shopify.money_format);
                    compareAtPriceElement.style.display = 'inline';
                } else {
                    compareAtPriceElement.style.display = 'none';
                }
            }

            if (percentageDifferenceElement) {
                const priceNumeric = parseFloat(selectedPrice.replace(/[^0-9.-]+/g, ""));
                const compareAtPriceNumeric = parseFloat(selectedCompareAtPrice.replace(/[^0-9.-]+/g, ""));

                if (compareAtPriceNumeric > 0 && compareAtPriceNumeric > priceNumeric) {
                    const percentageDifference = ((compareAtPriceNumeric - priceNumeric) / compareAtPriceNumeric) * 100;
                    percentageDifferenceElement.textContent = `-${Math.round(percentageDifference)}%`;
                    percentageDifferenceElement.style.display = 'inline';
                } else {
                    percentageDifferenceElement.style.display = 'none';
                }
            }
        }
    }

    function applyUpdates() {
        const colorSwatches = document.querySelectorAll('.color-swatch__radio');

        colorSwatches.forEach(function(swatch) {
            swatch.removeEventListener('change', swatchChangeHandler);
            swatch.addEventListener('change', swatchChangeHandler);

            if (swatch.checked) {
                updatePrice(swatch);
            }
        });

        updateFilterGroups();
    }

    function swatchChangeHandler(event) {
        updatePrice(event.target);
    }

    function updateFilterGroups() {
        var filterGroups = document.querySelectorAll('.collection__filter-group');

        filterGroups.forEach(function(group) {
            var filterDivmobile = group.querySelector('#mobile-filter-p-m-product-brand_shortname');
            var filterDiv = group.querySelector('#filter-p-m-product-brand_shortname');
            if (filterDiv) {
                group.style.display = 'none';
            } else if (filterDivmobile) {
                group.style.display = 'none';
            }
        });
    }

    applyUpdates();

    window.addEventListener('popstate', function() {
        applyUpdates();
    });

    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    const debouncedApplyUpdates = debounce(applyUpdates, 50);

    const observer = new MutationObserver(function(mutations) {
        for (let mutation of mutations) {
            if (mutation.type === 'childList' || mutation.type === 'attributes') {
                debouncedApplyUpdates();
                break;
            }
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true
    });

    (function(history) {
        const pushState = history.pushState;
        const replaceState = history.replaceState;

        history.pushState = function(state) {
            if (typeof history.onpushstate == "function") {
                history.onpushstate({
                    state: state
                });
            }
            setTimeout(applyUpdates, 0);
            return pushState.apply(history, arguments);
        };

        history.replaceState = function(state) {
            if (typeof history.onreplacestate == "function") {
                history.onreplacestate({
                    state: state
                });
            }
            setTimeout(applyUpdates, 0);
            return replaceState.apply(history, arguments);
        };
    })(window.history);

    var headerDiv = document.getElementById('shopify-section-header');

    if (window.matchMedia("(max-width: 640px)").matches) {
        if (headerDiv) {
            headerDiv.addEventListener('click', function() {
                var isFixedDivs = headerDiv.getElementsByClassName('is-fixed');

                if (isFixedDivs.length > 0) {
                    headerDiv.style.setProperty('z-index', '3', 'important');
                } else {
                    headerDiv.style.setProperty('z-index', '4', 'important');
                }
            });
        }
    }
});
